<template>
  <div>
    <tool-bar
      :title="title"
      :right-menu-actions="toolbarActionsList"
      :showSubTitle="false"
      :showLenderCobrandingData="false"
    ></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <refresh-item
      :show="refreshItemVisible"
      @onRefresh="onRefreshClicked"
    ></refresh-item>

    <div v-if="officesVisible" class="margin_top_20">
      <div v-for="officeDetails in officesDetails" :key="officeDetails.office.id">
        <office-item
          class="margin-top-10 margin-bottom-10 margin-left-5 margin-right-5 background-color-white"
          :office-details="officeDetails"
          @onOfficeSelected="onOfficeSelected"
        ></office-item>
      </div>
    </div>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import DataSource from "../../data/DataSource";
import PrefManager from "../../data/model/PrefManager";
import RefreshItem from "../layout/RefreshItem";
import OfficeItem from "../layout/OfficeItem";
import { ToolbarMenuItems } from "../../utils/ToolbarMenuItems";
import CoBrandingDataHolder from "../../data/model/CoBrandingDataHolder";

export default {
  name: "OfficeActivity",
  components: { ErrorAlertItem, ToolBar, Loading, RefreshItem, OfficeItem },
  data: () => ({
    title: "Office",
    refreshItemVisible: false,
    officesVisible: false,
    officesDetails: [],
    loading: false,
    errorAlertEvent: false,
    networkError: {}
  }),
  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onRefreshClicked() {
      this.refreshItemVisible = false;
      this.fetchOffices();
    },

    onOfficeSelected(officeDetails) {
      PrefManager.setUserOfficeId(officeDetails.office.id);
      PrefManager.setUserOfficeName(officeDetails.office.name);
      this.loading = true;
      let defaultNavigateActivty = Activities.HOME;
      DataSource.getRetailerDetailsFromOfficeId(officeDetails.office.id)
        .then(retailerDetailsRes => {
          if (retailerDetailsRes.errorOccurred) {
            this.showError(retailerDetailsRes.data);
            this.officesVisible = true;
          } else {
            const retailerDetails = retailerDetailsRes.data;
            if (retailerDetails && retailerDetails.retailerName) {
              DataSource.getRetailerConfig({ retailerName: retailerDetails.retailerName })
                .then(retailerConfigRes => {
                  if (retailerConfigRes.errorOccurred) {
                    this.showError(retailerDetailsRes.data);
                    this.officesVisible = true;
                  } else {
                    PrefManager.setRetailerConfig(retailerConfigRes.data);
                    CoBrandingDataHolder.setCoBrandingData(retailerConfigRes.data);
                    defaultNavigateActivty = retailerConfigRes.data.skipLoanListHomePage 
                        ? Activities.CUSTOMER_PHONE_NUMBER : Activities.HOME;
                    ActivityNavigator.navigateTo(defaultNavigateActivty);
                  }
                })
            } else {
              PrefManager.setRetailerConfig({
                retailerName: "",
                usePriceForLoanAmount: false,
                useLeadForLoanCreation: false,
                enforceLeadForLoanCreation: false
              });
              ActivityNavigator.navigateTo(defaultNavigateActivty);
            }
          }
        })
    },

    fetchOffices() {
      this.loading = true;
      DataSource.getAllOfficeDetails()
        .then(officesDetailsRes => {
          this.loading = false;
          if (officesDetailsRes.errorOccurred) {
            this.showError(officesDetailsRes.data);
            this.refreshItemVisible = true;
          } else {
            this.officesDetails = officesDetailsRes.data;
            if (this.officesDetails && this.officesDetails.length > 0) {
              if (this.officesDetails.length === 1) {
                PrefManager.setMultipleOfficePresent(false);
                this.onOfficeSelected(this.officesDetails[0]);
              } else {
                PrefManager.setMultipleOfficePresent(true);
                this.officesVisible = true;
              }
            }
          }
        })
    }
  },

  created: function () {
    this.fetchOffices();
  },

  computed: {
    toolbarActionsList() {
      return [ToolbarMenuItems.CONTACT_SUPPORT, ToolbarMenuItems.LOGOUT];
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>
